export interface SeoTagsInfo {
    title: string;
    canonicalSlug?: string;
    tags: {
        name?: string;
        property?: string;
        content: string;
    }[];
}

export const mapPageTags: SeoTagsInfo = {
    title: 'Map AI | Location analysis tool',
    tags: [
      {
        name: 'description',
        content:
          'Find where to move and do business with a 1-mile resolution at Map AI location intelligence platform. Access demand forecasting, competitive market analysis, and neighborhood analysis, including detailed demographics by zip code vs. 1 mile, real estate analytics, and more.',
      },
      {
        name: 'keywords',
        content:
          'Map-ai, population density by zip, median income by zip code map, median income map, median household income map, retail store location analysis, location analysis, location intelligence, competitive landscape analysis, map ai',
      },
      {
        property: 'og:title',
        content: 'Map AI | Location analysis tool',
      },
      {
        property: 'og:description',
        content:
          'Find where to move and do business with a 1-mile resolution at Map AI location intelligence platform.',
      },
      {
        property: 'og:url',
        content: 'https://interactive-map-ai.com/',
      },
    ]
};

export const aboutAiChatPageTags: SeoTagsInfo = {
  title: 'How AI Business Location Analysis Works | Map AI',
  canonicalSlug: '/chat/about',
  tags: [
    {
      name: 'description',
      content:
        'Learn how Map AI analyzes any US business location. Ask about demographics, competition, and traffic — get real data and map visualizations. No analyst needed.',
    },
    {
      name: 'keywords',
      content:
        'how business location analysis works, location intelligence tool guide, demographic data for small business, site selection research, ai location comparison, map ai help',
    },
    {
      property: 'og:title',
      content: 'How AI Business Location Analysis Works | Map AI',
    },
    {
      property: 'og:description',
      content:
        'Learn how Map AI analyzes any US business location. Ask about demographics, competition, and traffic — get real data and map visualizations. No analyst needed.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/chat/about',
    },
  ]
}

export const aiPageTags: SeoTagsInfo = {
  title: 'AI Business Location Analysis | Map AI',
  canonicalSlug: '/chat',
  tags: [
    {
      name: 'description',
      content:
        'Find the right business location before you sign. Check demographics, competition, and traffic for any US address. Real data, plain English.',
    },
    {
      name: 'keywords',
      content:
        'business location analysis, site selection tool, location intelligence, demographic data, traffic data, competition analysis, small business location research, map ai',
    },
    {
      property: 'og:title',
      content: 'AI Business Location Analysis Tool | Map AI',
    },
    {
      property: 'og:description',
      content:
        'Find the right business location before you sign. Check demographics, competition, and traffic for any US address. Real data, plain English.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/chat',
    },
  ]
}
export const reportsPageTags: SeoTagsInfo = {
  title: 'Map AI | Location Analysis Tool & Reporting System',
  canonicalSlug: '/reports/order',
  tags: [
    {
      name: 'description',
      content:
        'Map AI location intelligence platform and reporting system for a detailed neighborhood analysis, business location analysis, demand forecasting, and more.',
    },
    {
      name: 'keywords',
      content:
        'Map ai, map-ai, mapai, ai demand forecasting, retail demand forecasting, revenue forecasting, sales forecasting tools, demand forecasting software, demographics by zip, top neighborhoods',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location Analysis Tool & Reporting System',
    },
    {
      property: 'og:description',
      content:
        'Map AI location intelligence platform and reporting system for a detailed neighborhood analysis.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/reports/order',
    },
  ]
}

export const dataSourcesPageTags: SeoTagsInfo = {
  title: 'Map AI | Location intelligence for business & life',
  canonicalSlug: '/info/data-sources',
  tags: [
    {
      name: 'description',
      content:
        'Map AI: the Data You Can Trust. Map AI’s location intelligence tool gathers data from 100+ sources to provide our clients with high-resolution and up-to-date insights for life and business decision-making.',
    },
    {
      name: 'keywords',
      content:
        'Map ai, map-ai, mapai, demand forecast accuracy, location analysis tools, where do I live, where should I live, area median income, location intelligence platform',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location intelligence for business & life',
    },
    {
      property: 'og:description',
      content:
        'Map AI: the Data You Can Trust. Map AI’s location intelligence tool provides high-resolution and up-to-date insights.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/info/data-sources',
    },
  ]
}

export const compareLocationsPageTags: SeoTagsInfo = {
  title: 'Map AI | Compare Locations',
  canonicalSlug: '/comparative-location-tool',
  tags: [
    {
      name: 'description',
      content:
        'Compare Locations with Map AI location intelligence platform. Analyze demographics, income, education, and more at a 1-mile resolution. Quick informed decisions for life and business.',
    },
    {
      name: 'keywords',
      content:
        'compare locations tool, compare sites, compare demographics, Map ai, location comparison software, demographic comparison, neighborhood analysis, site selection tool, location intelligence platform',
    },
    {
      property: 'og:title',
      content: 'Map AI | Compare Locations',
    },
    {
      property: 'og:description',
      content:
        'Compare Locations with Map AI location intelligence platform. Analyze demographics, income, education, and more at a 1-mile resolution. Quick informed decisions for life and business.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/comparative-location-tool',
    },
  ],
};
export const settingsPageTags: SeoTagsInfo = {
  title: 'Map AI | Location analysis',
  canonicalSlug: '/user/subscription',
  tags: [
    {
      name: 'description',
      content:
        'Accessible location analysis for life and business: 50+ parameters at 1-mile resolution, starting from $4.95.',
    },
    {
      name: 'keywords',
      content:
        'Map ai subscription, map-ai, mapai, best location intelligence software, coffee shop location analysis, grocery demand forecasting, retail store location analysis, laundromat location analysis, median household income by zip code map, map of median income',
    },
    {
      property: 'og:title',
      content: 'Map AI | Location analysis',
    },
    {
      property: 'og:description',
      content:
        'Accessible location analysis for life and business: 50+ parameters at 1-mile resolution.',
    },
    {
      property: 'og:url',
      content: 'https://interactive-map-ai.com/user/subscription',
    },
  ]
}
